<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field
              ref="searchRef"
              @search="search"
              @change="checkSearch($event)"
            ></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <refresh-button @refresh="refreshData()"></refresh-button>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>

            <!-- Dialog for Add, View Edit  -->
            <settlement-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @downloadDialog="downloadExcelTrans"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
              :hideSave="dialogType === 'view'"
              showDownload
            >
              <!-- <v-container grid-list-xs> -->
              <!-- <v-layout justify-center> -->
              <!-- <v-flex md12> -->
              <!-- Insert View Dialog Content BELOW-->
              <details-container
                ref="detailsRef"
                :data="viewData"
                :items="viewItems"
                :headers="transactionHeaders"
                :readOnly="dialogType === 'view'"
                showSettle
              />
              <!-- </v-flex> -->
              <!-- </v-layout> -->
              <!-- </v-container> -->
            </settlement-dialog>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="saveConfirmedAddDialog()"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <!-- <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">{{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                  }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn> -->
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel
            :openFilter="openFilter"
            style="background-color: white !important;"
          >
            <v-flex md2>
              <v-select
                v-model="filterCompany"
                :items="filterCompanies"
                label="Company"
                required
                solo
                clearable
                @change="checkCompany($event)"
              ></v-select>
            </v-flex>
            <v-flex md2>
              <v-select
                v-model="filterSubCompany"
                :items="filterSubCompanies"
                label="Sub Company"
                solo
                clearable
                required
                @change="checkSubCompany($event)"
              ></v-select>
            </v-flex>
            <v-flex md2>
              <v-select
                v-model="filterStatus"
                :items="filterStatuses"
                label="Status"
                solo
                clearable
                required
                @change="checkStatus($event)"
              ></v-select>
            </v-flex>
            <v-flex md3 style="padding: 15px;">
              <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFrom"
                  label="Date From"
                  prepend-inner-icon="event"
                  outline
                  dense
                  readonly
                  clearable
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateFrom"
                  @input="menu = false"
                  @change="checkFrom($event)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 style="padding: 15px;">
              <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateTo"
                  label="Date To"
                  prepend-inner-icon="event"
                  outline
                  dense
                  readonly
                  clearable
                ></v-text-field>
                <v-date-picker
                  ref="picker"
                  v-model="dateTo"
                  :max="dateTo"
                  :min="dateFrom"
                  @input="menu1 = false"
                  @change="checkTo($event)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </filter-panel>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon small v-if="header.sortable">{{
                    header.sortNum === 1 ? "arrow_downward" : "arrow_upward"
                  }}</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left text-uppercase text-no-wrap">
                {{ props.item.reference_no }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.sync_date_time
                    ? $dateFormat(props.item.sync_date_time, "YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td class="text-xs-center text-no-wrap">
                {{ $dateFormat(props.item.start_date, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-left text-uppercase text-no-wrap">
                {{
                  props.item.sub_company ? props.item.sub_company.name : "--"
                }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{
                  props.item.merchant_status === 2
                    ? "settled"
                    : props.item.merchant_status === 1
                    ? "approved"
                    : "pending"
                }}
              </td>
              <td class="text-xs-center">
                {{ $dateFormat(props.item.created_at, "YYYY-MM-DD") }}
              </td>
              <td class="text-xs-center">
                {{ $dateFormat(props.item.created_at, "HH:mm") }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_approved
                    ? $dateFormat(props.item.date_approved, "YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_approved
                    ? $dateFormat(props.item.date_approved, "HH:mm")
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_settled
                    ? $dateFormat(props.item.date_settled, "YYYY-MM-DD")
                    : "--"
                }}
              </td>
              <td class="text-xs-center">
                {{
                  props.item.date_settled
                    ? $dateFormat(props.item.date_settled, "HH:mm")
                    : "--"
                }}
              </td>

              <td class="text-xs-right">
                {{ $amountInPeso(props.item.total_amount) }}
              </td>
              <td class="text-xs-right">
                {{
                  props.item.amount_settled === null
                    ? "--"
                    : $amountInPeso(props.item.amount_settled)
                }}
              </td>

              <td class="text-no-wrap text-xs-center">
                <view-button
                  v-if="props.item.merchant_status !== 1"
                  @view="openViewDialog(props.item)"
                ></view-button>

                <v-tooltip top>
                  <v-btn
                    v-if="props.item.merchant_status === 1"
                    icon
                    slot="activator"
                    @click="openEditDialog(props.item)"
                  >
                    <v-icon color="blue">update</v-icon>
                  </v-btn>
                  <span>Settle</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import DetailsContainer from "@/components/details_container/SettlementDetailsContainer";
import SettlementDialog from "@/components/dialog/SettlementDialog";
import moment from "moment";
import XLSX from "xlsx";

export default {
  components: {
    DetailsContainer,
    SettlementDialog,
  },
  data() {
    return {
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,
      filterStatus: null,
      dateFrom: null,
      dateTo: null,
      menu: false,
      menu1: false,
      filterStatuses: [
        {
          text: "PENDING",
          value: 0,
        },
        {
          text: "APPROVED",
          value: 1,
        },
        {
          text: "SETTLED",
          value: 2,
        },
      ],
      title: "Settlement",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Reference No.",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Sync Date",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Company",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Status",
          align: "left",
          value: "code",
          sortable: false,
        },
        {
          text: "Date Created",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Time Created",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Date Approved",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Time Approved",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Date Settled",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Time Settled",
          align: "center",
          value: "code",
          sortable: false,
        },
        {
          text: "Gross Amount",
          align: "right",
          value: "code",
          sortable: false,
        },
        {
          text: "Settled Amount",
          align: "right",
          value: "code",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      transactionHeaders: [
        { text: "No", align: "center", sortable: false },
        {
          text: "Date",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Time",
          align: "left",
          value: "code",
          sortable: false,
        },
        // {
        //   text: "Location",
        //   align: "left",
        //   value: "city",
        //   sortable: false,
        // },
        {
          text: "Branch",
          align: "left",
          value: "province",
          sortable: false,
        },
        // {
        //   text: "Merchant ID",
        //   align: "left",
        //   sortable: false,
        // },
        {
          text: "Control No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Receipt Reference No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Card No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Device Serial",
          align: "left",
          sortable: false,
        },
        // {
        //   text: "Assigned Terminal",
        //   align: "left",
        //   sortable: false,
        // },
        // {
        //   text: "OR Number",
        //   align: "left",
        //   sortable: false,
        // },
        {
          text: "Amount",
          align: "right",
          sortable: false,
        },
        {
          text: "MDR",
          align: "right",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          align: "left",
          sortable: false,
        },
      ],
      unassignedHeaders: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Code",
          align: "left",
          value: "code",
          sortable: true,
        },
      ],
      items: [],
      unassignedItems: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        order: "",
        desc: false,
        company_id: null,
        sub_company_id: null,
        status: null,
        date_to: null,
        date_from: null,
      },

      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},
      viewItems: [],

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      selected: [],
      addDialog: false,
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.queryParams.sub_company_id = null;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.queryParams.sub_company_id = null;
      }
      this.setFilterSubCompanies();
      this.getData();
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
      }
      this.getData();
    },
    filterStatus: async function() {
      if (
        this.filterStatus !== null &&
        this.filterStatus !== undefined &&
        this.filterStatus !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.status = this.filterStatus;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.status = null;
      }
      this.getData();
    },
    dateFrom: async function() {
      if (
        this.dateFrom !== null &&
        this.dateFrom !== undefined &&
        this.dateFrom !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.dateFrom = this.dateFrom;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.dateFrom = null;
      }
      this.getData();
    },
    dateTo: async function() {
      if (
        this.dateTo !== null &&
        this.dateTo !== undefined &&
        this.dateTo !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.dateTo = this.dateTo;
      } else {
        this.queryParams.offset = 0;
        this.queryParams.dateTo = null;
      }
      this.getData();
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data

        let response = (await Services.getSettlements(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};
      this.$store.dispatch("startLoading");
      try {
        const response = await Services.getSettlement(id);
        data = await response.data;
      } catch (error) {
        this.$store.dispatch("endLoading");
      }
      this.$store.dispatch("endLoading");
      return data;
    },
    async setManualTypes() {
      this.unassignedItems = [];
      this.unassignedItems = (
        await Services.getUnassignedManualTypes({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id,
        })
      ).data;
    },
    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.addDialog = true;

      this.setManualTypes();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";

      try {
        let settlementData = await this.setData(data.id);

        this.viewData = settlementData;
        this.dialogStatus = true;
      } catch (error) {
        this.dialogLoading = false;
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "approve";

      try {
        let settlementData = await this.setData(data.id);

        this.viewData = settlementData;

        this.dialogStatus = true;
      } catch (error) {
        this.dialogLoading = false;
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
    },
    async saveAddDialog() {
      this.openConfirmDialog = true;
    },
    async saveConfirmedAddDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData;

      const body = {
        bank_reference_no: data.bank_reference_no,
        deposit_slip: data.deposit_slip,
      };

      console.log(body);

      try {
        const response = await Services.settleSettlement(data.id, body);
        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Settlement has been settled!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteManualType(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Manual type has been deleted!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      this.viewItems = [];

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeAddDialog() {
      this.selected = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.addDialog = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.unassignedItems.slice();
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    async setFilterCompanies() {
      this.filterCompanies = [];
      const items = (await Services.getCompanies({})).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterCompanies.push(data);
      }
    },
    async setFilterSubCompanies() {
      this.filterSubCompanies = [];
      const items = (
        await Services.getSubCompanies({
          company_id: this.filterCompany,
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id,
        };
        this.filterSubCompanies.push(data);
      }
    },
    async refreshData() {
      this.$refs.searchRef.clear();
      await this.getData();
    },
    checkSearch(e) {
      if (e !== undefined) {
        this.queryParams.search = e;
      }
    },
    checkCompany(e) {
      if (e !== undefined) {
        this.queryParams.company_id = e;
      }
    },
    checkSubCompany(e) {
      if (e !== undefined) {
        this.queryParams.sub_company_id = e;
      }
    },
    checkStatus(e) {
      if (e !== undefined) {
        this.queryParams.status = e;
      }
    },
    checkFrom(e) {
      if (e !== undefined) {
        const event = new Date(e);
        // this.queryParams.dateTo = e
        // Date().toISOString().slice(0, 10)
        const addday = event.setDate(event.getDate() + 7);
        const iso = new Date(addday).toISOString().slice(0, 10);
        this.dateTo = iso;
      }
    },
    checkTo(e) {
      if (e !== undefined) {
        this.queryParams.dateTo = e;
      }
    },
    async downloadExcel() {
      const wscols = [];
      const dataToDownload = [];
      const header = [];
      let items = [];

      let total_gross = 0;
      let total_settled = 0;

      if (
        this.queryParams.company_id &&
        this.queryParams.status == null &&
        this.queryParams.sub_company_id &&
        this.queryParams.search &&
        this.queryParams.dateFrom &&
        this.queryParams.dateTo
      ) {
        this.$infoBar({
          type: "error",
          text:
            "Data not available for Download, Please select valid Filter/s.",
        });

        return;
      }

      try {
        this.queryParams.limit = null;

        let response2 = (await Services.getSettlements(this.queryParams)).data;

        items = response2.data;
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      for (let i = 0; i < this.headers.length - 1; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length - 1; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
      }

      for (let e = 0; e < items.length; e++) {
        const theItem = [];

        theItem.push(items[e].reference_no ? items[e].reference_no : "--");
        theItem.push(
          items[e].sync_date_time
            ? this.$dateFormat(items[e].sync_date_time, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].start_date
            ? this.$dateFormat(items[e].start_date, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].sub_company ? items[e].sub_company.name.toUpperCase() : "--"
        );
        theItem.push(
          items[e].merchant_status === 2
            ? "SETTLED"
            : items[e].merchant_status === 1
            ? "APPROVED"
            : "PENDING"
        );
        theItem.push(
          items[e].created_at
            ? this.$dateFormat(items[e].created_at, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].created_at
            ? this.$dateFormat(items[e].created_at, "HH:mm")
            : "--"
        );
        theItem.push(
          items[e].date_approved
            ? this.$dateFormat(items[e].date_approved, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].date_approved
            ? this.$dateFormat(items[e].date_approved, "HH:mm")
            : "--"
        );
        theItem.push(
          items[e].date_settled
            ? this.$dateFormat(items[e].date_settled, "YYYY-MM-DD")
            : "--"
        );
        theItem.push(
          items[e].date_settled
            ? this.$dateFormat(items[e].date_settled, "HH:mm")
            : "--"
        );
        theItem.push(items[e].total_amount);
        theItem.push(items[e].amount_settled);

        dataToDownload.push(theItem);

        total_gross += items[e].total_amount;
        total_settled += items[e].amount_settled;
      }

      for (let e = 0; e < 2; e++) {
        const theItem_2 = [];

        for (let i = 0; i < items.length; i++) {
          theItem_2.push("");
        }

        dataToDownload.push(theItem_2);
      }

      const totalItems = [
        "TOTAL",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        total_gross,
        total_settled,
      ];

      dataToDownload.push(totalItems);

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
      // Dito
    },
    async downloadExcelTrans() {
      if (this.$refs.detailsRef.downloadData.length == 0) {
        return this.$infoBar({
          type: "info",
          text: "View Transaction First",
        });
      }
      const wscols = [];
      const dataToDownload = [];
      const header = [];
      let items = [];

      let total_amount = 0;
      let total_mdr = 0;

      try {
        items = this.$refs.detailsRef.downloadData;
      } catch (error) {
        this.$infoBar({
          type: "error",
          text: "No network or server connection",
        });
      }

      for (let i = 0; i < this.transactionHeaders.length - 1; i++) {
        header.push(this.transactionHeaders[i].text.toUpperCase());
      }

      header.shift();
      dataToDownload.push(header);

      for (let i = 0; i < this.transactionHeaders.length - 1; i++) {
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
        wscols.push({ wch: 15 });
      }

      for (let e = 0; e < items.length; e++) {
        const theItem = [];

        theItem.push(items[e].date);
        theItem.push(items[e].time);
        // theItem.push(items[e].location ? items[e].location : "--");
        theItem.push(items[e].branch ? items[e].branch : "--");
        // theItem.push(items[e].merchant_id ? items[e].merchant_id : "--");
        theItem.push(items[e].control_no ? items[e].control_no : "--");
        theItem.push(items[e].ticket_no ? items[e].ticket_no : "--");
        theItem.push(items[e].card_no ? items[e].card_no : "--");
        theItem.push(items[e].device_serial ? items[e].device_serial : "--");
        // theItem.push(
        //   items[e].terminal
        //     ? items[e].terminal
        //     : "--"
        // );
        // theItem.push(items[e].or_no ? items[e].or_no : "--");
        theItem.push(items[e].amount);
        theItem.push(items[e].mdr);
        theItem.push(items[e].action);
        theItem.push(items[e].remarks);

        dataToDownload.push(theItem);

        if (items[e].action === "SETTLE") {
          total_amount += items[e].amount;
          total_mdr += items[e].mdr;
        }
      }

      for (let e = 0; e < 1; e++) {
        const theItem_2 = [];

        for (let i = 0; i < items.length; i++) {
          theItem_2.push("");
        }

        dataToDownload.push(theItem_2);
      }

      const totalItems = [
        "TOTAL",
        // "",
        // "",
        // "",
        // "",
        "",
        "",
        "",
        "",
        "",
        "",
        total_amount,
        total_mdr,
      ];

      dataToDownload.push(totalItems);

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + " Transaction" + ".xlsx"],
        [this.title + " Transaction" + ".xlsm"],
        [this.title + " Transaction" + ".xlsb"],
        [this.title + " Transaction" + ".xlam"],
        [this.title + " Transaction" + ".biff8.xls", { bookType: "xls" }],
        [this.title + " Transaction" + ".biff5.xls", { bookType: "biff5" }],
        [this.title + " Transaction" + ".biff2.xls", { bookType: "biff2" }],
        [this.title + " Transaction" + ".xml.xls", { bookType: "xlml" }],
        [this.title + " Transaction" + ".xla"],
        [this.title + " Transaction" + ".ods"],
        [this.title + " Transaction" + ".fods"],
        [this.title + " Transaction" + ".csv"],
        [this.title + " Transaction" + ".txt"],
        [this.title + " Transaction" + ".slk"],
        [this.title + " Transaction" + ".eth"],
        [this.title + " Transaction" + ".htm"],
        [this.title + " Transaction" + ".dif"],
        [this.title + " Transaction" + ".dbf", { sheet: "Hidden" }],
        [this.title + " Transaction" + ".rtf"],
        [this.title + " Transaction" + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped></style>
